var map = {
	"./Untitled-1.png": 47226,
	"./active.png": 69845,
	"./add-button-small.png": 38575,
	"./add-button-white.png": 42289,
	"./add-button.png": 22149,
	"./asterisk.png": 69703,
	"./attachment-small.png": 78134,
	"./attachment-white.png": 87956,
	"./attachment.png": 83860,
	"./audio.png": 71901,
	"./broken-img.png": 20326,
	"./calendar.png": 6745,
	"./coefficient.png": 30296,
	"./color.png": 70902,
	"./concern-1.png": 91437,
	"./concern-2.png": 59670,
	"./concern-3.png": 13471,
	"./cta-1.png": 3223,
	"./cta-2.png": 79292,
	"./cta-3.png": 31557,
	"./daily-report/bear-happy.png": 83653,
	"./daily-report/bear-sad.png": 95235,
	"./daily-report/bear-settled.png": 9068,
	"./daily-report/breakfast-less-green.png": 16411,
	"./daily-report/breakfast-moderate-green.png": 20163,
	"./daily-report/breakfast-more-green.png": 70995,
	"./daily-report/clothes.png": 51040,
	"./daily-report/comment.png": 35903,
	"./daily-report/cream.png": 29374,
	"./daily-report/hygiene-pee.png": 844,
	"./daily-report/hygiene-peepoop.png": 11334,
	"./daily-report/hygiene-poop.png": 89962,
	"./daily-report/juice-yellow-all.png": 61761,
	"./daily-report/juice-yellow-less.png": 1753,
	"./daily-report/juice-yellow-most.png": 18419,
	"./daily-report/juice-yellow.png": 35943,
	"./daily-report/lunch-less-pink.png": 15543,
	"./daily-report/lunch-moderate-pink.png": 54295,
	"./daily-report/lunch-more-pink.png": 89071,
	"./daily-report/medicine-pink.png": 67193,
	"./daily-report/medicine.png": 80114,
	"./daily-report/milk-multi.png": 85087,
	"./daily-report/nap.png": 4401,
	"./daily-report/need-diaper.png": 31402,
	"./daily-report/potty-training.png": 24637,
	"./daily-report/snack-all.png": 39060,
	"./daily-report/snack-green.png": 85264,
	"./daily-report/snack-less.png": 81790,
	"./daily-report/snack-moderate.png": 51230,
	"./daily-report/snack.png": 28990,
	"./daily-report/snack2-all.png": 4868,
	"./daily-report/snack2-less.png": 87310,
	"./daily-report/snack2-moderate.png": 14414,
	"./daily-report/snack2.png": 44462,
	"./daily-report/snack3-all.png": 59185,
	"./daily-report/snack3-less.png": 31369,
	"./daily-report/snack3-moderate.png": 77729,
	"./daily-report/snack3.png": 43959,
	"./daily-report/temperature.png": 32838,
	"./daily-report/time.png": 30397,
	"./daily-report/toilet-visits.png": 8980,
	"./daily-report/water-less.png": 28947,
	"./daily-report/water-moderate.png": 5051,
	"./daily-report/water-more.png": 7779,
	"./daily-report/wipes.png": 6888,
	"./description.png": 63053,
	"./edit-yellow.png": 4126,
	"./edit.png": 23943,
	"./educore-new.png": 4199,
	"./exam-black.png": 75836,
	"./exam.png": 74594,
	"./express_grey.png": 66157,
	"./folder.png": 54055,
	"./formSection.png": 41952,
	"./g-drive.png": 12811,
	"./google_drive.png": 18323,
	"./hara-bhara-circle.png": 44521,
	"./hyperlink-small.png": 7335,
	"./hyperlink-white.png": 79257,
	"./hyperlink-yellow.png": 26680,
	"./hyperlink.png": 51933,
	"./image-1.png": 4042,
	"./image-2.png": 61473,
	"./image-3.png": 40344,
	"./image.png": 90004,
	"./info-slim-yellow.png": 30108,
	"./label-tag.png": 18694,
	"./lesson/actions.png": 52875,
	"./lesson/connections.png": 73741,
	"./lesson/goal.png": 93829,
	"./lesson/hyperlink.png": 56496,
	"./lesson/idea.png": 23993,
	"./lesson/inquiry.png": 12669,
	"./lesson/key-concepts.png": 86129,
	"./lesson/learner-profile.png": 20401,
	"./lesson/learning-approaches.png": 35633,
	"./lesson/lesson-focus.png": 78163,
	"./lesson/line-chart.png": 69921,
	"./lesson/prior-learning.png": 63247,
	"./lesson/related-concepts.png": 63773,
	"./lesson/scope-sequence.png": 77478,
	"./lesson/student-question.png": 69374,
	"./lesson/teacher-question.png": 75499,
	"./lib-1.png": 69860,
	"./lib-2.png": 83423,
	"./lib-3.png": 21686,
	"./lib-4.png": 95945,
	"./login-img.png": 62734,
	"./logo-thumb.png": 96561,
	"./logo-thumb2.png": 19479,
	"./logo-thumb2_.png": 2544,
	"./logo.png": 82806,
	"./my_folder.png": 67098,
	"./noimage.png": 78863,
	"./observationGallery.png": 36655,
	"./orders-completed.png": 31276,
	"./orders-pending.png": 34070,
	"./orders-total.png": 45737,
	"./pdf.png": 11577,
	"./pdf_file_icon.png": 57938,
	"./pegboard-bg.png": 56819,
	"./person-1.png": 75546,
	"./person-2.png": 35441,
	"./person-3.png": 3400,
	"./person-4.png": 83015,
	"./placeholder150.png": 29584,
	"./play.png": 2877,
	"./question-list-close.png": 85337,
	"./question-list-open.png": 429,
	"./reactions/1.png": 92455,
	"./reactions/2.png": 72396,
	"./reactions/3.png": 41493,
	"./reactions/4.png": 84986,
	"./reactions/default.png": 88433,
	"./remove-red.png": 69561,
	"./report-1.png": 19991,
	"./report-2.png": 14908,
	"./report-3.png": 48773,
	"./report-4.png": 64106,
	"./report-5.png": 14867,
	"./report-6.png": 40376,
	"./report-7.png": 13089,
	"./report-8.png": 56934,
	"./seat-blue.png": 81595,
	"./seat-green.png": 88742,
	"./seat-icon.png": 71596,
	"./setup/curriculumbuilder.png": 36055,
	"./setup/discount.png": 54672,
	"./setup/feestructure.png": 38006,
	"./setup/gears.png": 37537,
	"./setup/gradesandacademic.png": 10311,
	"./setup/policies.png": 4511,
	"./setup/registrationperiods.png": 16278,
	"./setup/schoolsetup.png": 17702,
	"./setup/services.png": 79637,
	"./setup/tt.png": 34473,
	"./signin-google.png": 46121,
	"./signin-microsoft.png": 44198,
	"./social-platforms/fb.png": 13718,
	"./social-platforms/ig.png": 64714,
	"./social-platforms/li.png": 46983,
	"./social-platforms/tt.png": 22938,
	"./social-platforms/tw.png": 31249,
	"./social-platforms/wa.png": 54390,
	"./social-platforms/yt.png": 1953,
	"./status.png": 79421,
	"./student-list/age.png": 87245,
	"./student-list/attendance.png": 92847,
	"./student-list/awards.png": 85640,
	"./student-list/behave.png": 54924,
	"./student-list/daily-report-icon.png": 4180,
	"./student-list/daily-report.png": 64992,
	"./student-list/information.png": 64918,
	"./student-list/online-green.png": 86797,
	"./student-list/online-red.png": 66957,
	"./student-list/pastoral-care.png": 79978,
	"./student-list/photo-camera-green.png": 73664,
	"./student-list/photo-camera-red.png": 72332,
	"./student-list/quick-time-white.png": 11259,
	"./student-list/redeem.png": 21406,
	"./student-list/reset-time.png": 87663,
	"./student-list/select-time-white.png": 34230,
	"./student-list/student-list.png": 91640,
	"./student-list/timings.png": 17621,
	"./student-list/total-points.png": 86436,
	"./student-list/trophy.png": 94756,
	"./student-list/walking-solid-blue.png": 94518,
	"./student-list/walking-solid-orink.png": 6853,
	"./student-list/warning.png": 55972,
	"./sub-1.png": 24759,
	"./sub-2.png": 828,
	"./sub-3.png": 53093,
	"./sub-4.png": 82666,
	"./submit-exam.png": 4895,
	"./thumbs-up.png": 9304,
	"./timetable.png": 72298,
	"./trans-1.png": 14215,
	"./trans-2.png": 45740,
	"./trans-3.png": 28629,
	"./trophy.png": 29061,
	"./u-1.png": 83476,
	"./u-2.png": 57967,
	"./u-3.png": 18950,
	"./user-timeline/activity.png": 85566,
	"./user-timeline/agenda.png": 31005,
	"./user-timeline/announcement.png": 90200,
	"./user-timeline/appointment.png": 12494,
	"./user-timeline/assignment.png": 77030,
	"./user-timeline/attachment-pink.png": 77717,
	"./user-timeline/awards.png": 54575,
	"./user-timeline/banner.png": 38835,
	"./user-timeline/calendar-green.png": 70797,
	"./user-timeline/change_password.png": 93861,
	"./user-timeline/check.png": 35357,
	"./user-timeline/contact.png": 28349,
	"./user-timeline/daily-report.png": 45999,
	"./user-timeline/discount-voucher.png": 87289,
	"./user-timeline/download.png": 30037,
	"./user-timeline/event.png": 78297,
	"./user-timeline/exam.png": 22380,
	"./user-timeline/fees-pink.png": 8510,
	"./user-timeline/grade.png": 4708,
	"./user-timeline/group-report.png": 4821,
	"./user-timeline/health.png": 85155,
	"./user-timeline/home.png": 55748,
	"./user-timeline/journal.png": 83836,
	"./user-timeline/mail-blue.png": 92099,
	"./user-timeline/media-approval.png": 2497,
	"./user-timeline/messaging.png": 57957,
	"./user-timeline/myclass.png": 38463,
	"./user-timeline/mydocument.png": 27068,
	"./user-timeline/newsletter.png": 31108,
	"./user-timeline/notification.png": 6536,
	"./user-timeline/nurse-2.png": 7063,
	"./user-timeline/online-class.png": 84615,
	"./user-timeline/photos.png": 79546,
	"./user-timeline/policy.png": 2375,
	"./user-timeline/poll.png": 9130,
	"./user-timeline/profile.png": 87534,
	"./user-timeline/retest.png": 99602,
	"./user-timeline/settings.png": 8294,
	"./user-timeline/survey.png": 7919,
	"./user-timeline/trophy.png": 97391,
	"./user-timeline/tutorial.png": 64527,
	"./user-timeline/videos.png": 58265,
	"./user-timeline/warning.png": 45169,
	"./wall-clock-red.png": 51964,
	"./where-we-are_grey.png": 21884,
	"./who-we-are_grey.png": 61233,
	"./youtube.png": 235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;